module.exports = __webpack_public_path__ + "img/all.38a97f4c.svg";